// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2JijE","modalFooterButton":"ModalNotes_modalFooterButton__2nVbN"};